export default [
    'error',
    'connect',
    'disconnect',
    'connectAbort',
    'connecting',
    'raw',
    'kickOut',
    'subscribe',
    'subscribeFail',
    'unsubscribe',
    'authStateChange',
    'authTokenChange',
    'subscribeStateChange',
    'subscribeRequest',
    'authenticate',
    'deauthenticate',
    'message'
]